import React, {useContext, useEffect, useState} from 'react';
import { UserRecoverContext } from "./ShareStates";
import PasswordResetErrorForm from "./PasswordResetErrorForm";
import {
    getUserPasswordResetToken,
    getQueryResult
} from "../../commonFunctions/GraphqlFunctions";

const PasswordResetActionForm = () => {
    const {token, updateDisplayForm, updateLoginUrl} = useContext(UserRecoverContext);
    const [errorValue, setErrorValue] = useState("");
    const [displayForm, setDisplayForm] = useState("");
    const [displayError, setDisplayError] = useState("none");
    const [mountReadOnce, setMountReadOnce] = useState("none");
    const [passwordValue, setPasswordValue] = useState("");
    const [userPasswordShowChecked, setUserPasswordShowChecked] = useState("");
    const [userPasswordInputType, setUserPasswordInputType] = useState("password");

    useEffect(() => {
        async function fetchData() {
            if (mountReadOnce === "none") {
                if (token !== null) {
                    let getTokenResult = await getUserPasswordResetTokenResult()
                    // console.log(getTokenResult)
                    if (getTokenResult !== undefined || getTokenResult !== null) {
                        if (getTokenResult.data['supportSiteUserPasswordResetCheckToken']['message'] !== undefined) {
                            let messageOutput = getTokenResult.data['supportSiteUserPasswordResetCheckToken']['message'];
                            console.log(messageOutput)
                            setDisplayForm("passwordErrorRequest");
                        }
                    }
                    else {
                        console.log(getTokenResult)
                        setDisplayError("block");
                    }
                }
                setMountReadOnce("visited");
            }
        }
        async function getUserPasswordResetTokenResult() {
            return await getQueryResult(getUserPasswordResetToken("checkToken"), {"token": token})
        }
        fetchData();
    }, [token, mountReadOnce, passwordValue, setMountReadOnce, updateDisplayForm])

    const inputChange = (event) => {
        event.preventDefault();
        if (event.target.id === "user_password") {
            setPasswordValue(event.target.value)
            setErrorValue("")
        }
        if (event.target.id === "show") {
            if (userPasswordShowChecked === "") {
                setUserPasswordShowChecked("checked");
                setUserPasswordInputType("text");
            }
            else {
                setUserPasswordShowChecked("");
                setUserPasswordInputType("password");
            }
        }
    }

    const submitAction = async (event) => {
        event.preventDefault();
        if (passwordValue === "") {
            setErrorValue("Password cannot be empty")
        }
        else {
            let submitPasswordResult = await getQueryResult(getUserPasswordResetToken("submitPassword"), {"token": token, "password": passwordValue})
            if (submitPasswordResult !== undefined || submitPasswordResult !== null) {
                if (submitPasswordResult.data['supportSiteUserPasswordResetCheckToken']['message'] !== undefined) {
                    let messageOutput = submitPasswordResult.data['supportSiteUserPasswordResetCheckToken']['message'];
                    if (messageOutput === "password not meet complexity") {
                        setErrorValue("You password must be at least 8 characters long and contain a letter, a uppercase letter, a number and a special character")
                    }
                    else {
                        console.log(messageOutput)
                        updateDisplayForm("passwordErrorRequest");
                    }
                }
                else{
                    updateLoginUrl(submitPasswordResult.data['supportSiteUserPasswordResetCheckToken']['returnToURL']);
                    updateDisplayForm("passwordResetConfirmation");
                }
            }
            else {
                console.log(submitPasswordResult);
                setDisplayError("block");
            }
        }
    }

    if (displayForm === "passwordErrorRequest") {
        return (
            <PasswordResetErrorForm />
        )
    }
    else {
        return (
            <React.Fragment>
                <h1>Please enter a new password</h1>
                <div className={"errorNotice"} style={{display: displayError}}>
                    There is error contacting the backend server, please contact administrator.
                </div>
                <div className={"groupedFormElements"}>
                    <input type={userPasswordInputType} name={"user_password"} id={"user_password"}
                           className={"required"}
                           placeholder={"Enter a password"} value={passwordValue} onChange={inputChange}></input>
                    <div className={"showPW"}>
                        <input type={"checkbox"} name={"show"} id={"show"} value={"showText"}
                               className={userPasswordShowChecked} onClick={inputChange}></input>
                        <label htmlFor={"show"}>Show</label>
                    </div>
                    <span id={"error_user_password"} className={"error"}>{errorValue}</span>
                </div>
                <button type={"submit"} id={"submit"} className={"formSubmit btn"} title={"Submit"} onClick={submitAction}>
                    <span>Reset Password</span>
                </button>
            </React.Fragment>
        )
    }
}

export default PasswordResetActionForm

